// /src/Components/Domain/components/WebsitePreview.jsx

import React from "react";
import {
  Copy,
  ExternalLink,
  Globe2,
} from "lucide-react";

export default function WebsitePreview({
  finalUrl,
  onCopyFinalUrl,
}) {
  if (!finalUrl) return null;

  return (
    <div className="mt-5 overflow-hidden rounded-2xl border bg-white shadow-sm">
      <div className="flex flex-col justify-between gap-3 border-b bg-gray-950 px-4 py-3 text-white md:flex-row md:items-center">
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold">
            <Globe2 size={17} className="text-emerald-400" />
            Live Website Preview
          </div>

          <p className="mt-1 break-all font-mono text-xs text-gray-400">
            {finalUrl}
          </p>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onCopyFinalUrl}
            className="inline-flex h-9 items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/5 px-3 text-xs font-semibold text-gray-200 hover:bg-white/10"
          >
            <Copy size={13} />
            Copy URL
          </button>

          <a
            href={finalUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex h-9 items-center justify-center gap-2 rounded-xl bg-emerald-500 px-3 text-xs font-semibold text-white hover:bg-emerald-600"
          >
            <ExternalLink size={13} />
            Open Full Page
          </a>
        </div>
      </div>

      <div className="h-[calc(100vh-120px)] min-h-[720px] w-full bg-gray-100">
        <iframe
          title="Live website preview"
          src={finalUrl}
          className="h-full w-full border-0 bg-white"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allow="clipboard-read; clipboard-write; fullscreen"
        />
      </div>
    </div>
  );
}